import { Edition } from "./edition";
import { Issue } from "./issue";
import { PubChannel } from "./pub-channel";

export class Target {
    public __classname__: string = 'Target';

    public PubChannel : PubChannel | null = null;
	public Issue : Issue | null = null;
	public Editions : Edition | null = null;

    /**
     * @deprecated DISCONTINUED since 10.12
     */
	public PublishedDate : string | null = null;
    /**
     * @deprecated DISCONTINUED since 10.12
     */
	public PublishedVersion : string | null = null;

    constructor(params : TargetNamedProperties) {
        this.PubChannel = params.PubChannel;
        this.Issue = params.Issue ?? null;
        this.Editions = params.Editions ?? null;
    }
}

export interface TargetNamedProperties {
    PubChannel: PubChannel,
    Issue?: Issue,
    Editions?: Edition,
}